export default {
    route: {
        home: 'Home',
        systemManage: 'System manage',
		informationManage:'Information manage',
		realTimeData:'Realtime data',
		workshopMessage:'Workshop message',
        userList: 'User list',
        addUser: 'Add user',
        updateUser: 'Modify user',
        deleteUser: 'Delete user',
        deleteMultiUser: 'Delete MultiUser',
        resetPassword: 'Reset Password',
        assignRole: 'Assign roles to users',
        roleList: 'Role list',
        selectAllRole: 'Query Role',
        selectRolePermission: 'Query permissions',
        addRole: 'Add role',
        updateRole: 'Modify role',
        deleteRole: 'Delete role',
        deleteMultiRole: 'Delete multiRole',
        assignPermission: 'Assign permissions',
        schedule: 'Schedule job',
        errorPages: 'Error pages',
        page401: '401',
        page404: '404',
        wxManage: 'Wechat manage',
        wxAccount: 'Official account',
        wxAccountSave: 'Save account',
        wxAccountDelete: 'Delete account',
        wxMenu: 'Wechat menu',
        wxUser: 'Wechat user',
        msgTemplate: 'Template msg',
        wxQrCode: 'Wechat qrcode',
        msgReplyRule: 'Reply rule',
        wxMsg: 'Wechat msg',
        wxAssets: 'Assets Manage',
        swiper: 'Carousel',
        chartAnalysis: 'Chart Analysis',
        farinogram: 'Farinogram',
        realFlow: 'Real-Time flow',
        historyFlow: 'History flow',
        formulaManage: 'Formula manage',
        wheatFormula: 'Wheat formula',
        flourFormula: 'Flour formula',
        addWheatFormula: 'Add Wheat Formula',
        addFlourFormula: 'Add Flour Formula',
        verifyWheatFormula: 'Verify Wheat Formula',
        verifyFlourFormula: 'Verify Flour Formula',
        materialManage: 'Material Manage',
        productionSchedule: 'Production Schedule',
        wheatFormulaSchedule: 'Wheat Formula Schedule'
    },
    navbar: {
        home: 'Home',
        logOut: 'Log Out',
        profile: 'Profile',
        theme: 'Theme',
        size: 'Global Size'
    },
    login: {
        title: 'Login Form',
        logIn: 'Login',
        username: 'Username',
        password: 'Password',
        any: 'any'
    },
    profile: {
        profile: 'Profile',
        username: 'Username',
        role: 'Role',
        avatar: 'Avatar',
        password: 'Password',
        changePassword: 'Change password',
        oldPassword: 'Old password',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
        oldPasswordTip: 'Please enter the original password',
        newPasswordTip: 'Please enter the new password',
        confirmNewPasswordTip: 'Please enter the new password again',
        telephone: 'Telephone',
        realName: 'Real name',
        nickname: 'Nickname',
        lastLoginTime: 'Last login time',
        createUser: 'Create User'
    },
    role: {
        roleCode: 'Role code',
        roleName: 'role',
        roleDesc: 'Role description',
        roleLevel: 'Role level',
        Menus: 'Permission menu',
        handle:'handle'
    },
    table: {
        search: 'Search',
        add: 'Add',
        export: 'Export',
        id: 'ID',
        actions: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        create: 'Create',
        update: 'Update',
        cancel: 'Cancel',
        confirm: 'Confirm',
        batchDelete: 'Batch delete',
        access: 'Access',
        copy: 'Copy',
        save: 'Save',
        creator:"Creator",
        createTime:"Create Time",
        verify: 'Verify',
        send: 'Send',
        receive: 'Receive'
    },
    tagsView: {
        refresh: 'Refresh',
        close: 'Close',
        closeOthers: 'Close Others',
        closeAll: 'Close All'
    },
    settings: {
        title: 'Page style setting',
        theme: 'Theme Color',
        tagsView: 'Open Tags-View',
        fixedHeader: 'Fixed Header',
        sidebarLogo: 'Sidebar Logo'
    },
    wx: {
        wxName: 'Account name',
        wxType: 'Account type',
        verified: 'Verified',
        accessInfo: 'Access info',
        accessUrl: 'Access url',
        selectMaterial: 'Select material',
        pCPreview: 'Preview is not supported',
        wechatPlayed: 'Played normally in wechat',
        saveUrl: 'Save url',
        linkUrl: 'Link',
        rank: 'sort(asc)'
    },
    oss: {
        cloudStorage: 'Cloud storage config',
        batchDelete: 'Batch delete',
        createTime: 'Create time',
        storageType: 'Storage type',
        qiNiu: 'Qi niu',
        aliCloud: 'Ali Cloud',
        qCloud: 'QCloud',
        domain: 'Domain',
        pathPrefix: 'Path prefix',
        spaceName: 'Space name',
        domainTips: 'Qiniu domain',
        prefixTips: 'Default is empty',
        accessKeyTips: 'Qiniu AccessKey',
        secretKeyTips: 'Qiniu SecretKey',
        spaceTips: 'Qiniu Bucket Name',
        aliDomainTips: 'Ali Cloud domain',
        endPointTips: 'Ali Cloud EndPoint',
        accessKeyIdTips: 'Ali Cloud AccessKeyId',
        accessKeySecretTips: 'Ali Cloud AccessKeySecret',
        bucketTips: 'Ali Cloud BucketName',
        tencentDomainTips: 'QCloud domain',
        appIdTips: 'QCloud AppId',
        secretIdTips: 'QCloud SecretId',
        qCloudSecretKeyTips: 'QCloud SecretKey',
        qBucketTips: 'QCloud BucketName',
        bucketRegion: 'Bucket region',
        regionTips: 'South China: GZ, North China: TJ, East China: SH'
    },
    formula: {
        formulaAdd: 'Add Formula',
        formulaUpdate: 'Update Formula',
        formulaNo: 'FormulaNo',
        formulaName: 'Formula Name',
        batchNo: 'BatchNo',
        productionLine: 'Production Line',
        processName: 'Process Section',
        variety: 'Variety',
        storeNo: 'StoreNo',
        ratio: 'Ratio',
        batchWeight: 'Batch Weight',
        weight: 'Weight',
        mixTime: 'Mixing Time',
        flourRatio: 'Flour Percent',
        totalFlow: 'Total Flow',
        setWater: 'Set Water',
        manualAdd: 'Manual Add',
        flourBatchWeight: 'Flour Batch Weight',
        traceBatchWeight: 'Trace Batch Weight',
        excBatchWeight: 'Excipients Batch Weight',
        verifyState: 'Verify State',
        sendState: 'Send State',
        receiveState: 'Receive State'
    },
    taskList: {
        taskIdWhole: 'Task ID'
    },
    material: {
        materialType: 'Material Type',
        secondMaterialType: 'Secondary type',
        materialName: 'Material Name'
    }
}
